// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.headerStyle {
  display: flex;
  align-items: center;
  background-color: #fff;
  height: 55px;
  width: 100%;
  position: relative;
  top: 0;
  z-index: 999;
  /* box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.05); */
  border: 1px solid #77797b;
}

.lineClass {
  height: 6px;
  width: 100%;
  position: absolute;
  top: 0px;
}

.text {
  color: black;
  font-size: 18px;
  font-weight: 700;
}

.textResposivo {
  color: black;
  font-size: 18px;
  font-weight: 700;
}

.logoClass {
  width: 160px;
  height: 36px;
  margin-left: 50px;
}

.containerLogo {
  display: flex;
  flex-direction: row;
  margin-top: 3px;
}

.ContainerInfosLogin {
  display: flex;
  padding: 3px 15px 0px 79px;
  width: calc(100% - 55px);
  align-items: center;
  justify-content: space-between;
}

@media (min-width: 100px) and (max-width: 835px) {
  .textResposivo {
    margin-left: 0px;
  }

  .text {
    display: none;
  }
}

@media (min-width: 835px) {
  .textResposivo {
    display: none;
  }

  .text {
    display: flex;
  }
}
`, "",{"version":3,"sources":["webpack://./src/componentes/headerDefault/header.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,YAAY;EACZ,qDAAqD;EACrD,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,wBAAwB;EACxB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".headerStyle {\n  display: flex;\n  align-items: center;\n  background-color: #fff;\n  height: 55px;\n  width: 100%;\n  position: relative;\n  top: 0;\n  z-index: 999;\n  /* box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.05); */\n  border: 1px solid #77797b;\n}\n\n.lineClass {\n  height: 6px;\n  width: 100%;\n  position: absolute;\n  top: 0px;\n}\n\n.text {\n  color: black;\n  font-size: 18px;\n  font-weight: 700;\n}\n\n.textResposivo {\n  color: black;\n  font-size: 18px;\n  font-weight: 700;\n}\n\n.logoClass {\n  width: 160px;\n  height: 36px;\n  margin-left: 50px;\n}\n\n.containerLogo {\n  display: flex;\n  flex-direction: row;\n  margin-top: 3px;\n}\n\n.ContainerInfosLogin {\n  display: flex;\n  padding: 3px 15px 0px 79px;\n  width: calc(100% - 55px);\n  align-items: center;\n  justify-content: space-between;\n}\n\n@media (min-width: 100px) and (max-width: 835px) {\n  .textResposivo {\n    margin-left: 0px;\n  }\n\n  .text {\n    display: none;\n  }\n}\n\n@media (min-width: 835px) {\n  .textResposivo {\n    display: none;\n  }\n\n  .text {\n    display: flex;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
